// useClientIP.js
import { useEffect, useState } from "react";

const useClientIP = () => {
  const [ip, setIP] = useState("");

  useEffect(() => {
    const fetchPublicIP = async () => {
      try {
        const response = await fetch("https://api.ipify.org?format=json");
        const data = await response.json();
        setIP(data.ip);
      } catch (error) {
        console.error("Error fetching public IP:", error);
      }
    };

    fetchPublicIP();
  }, []);

  return ip;
};

export default useClientIP;
